import { ReactNode } from 'react'
import { useAuth } from '@/services/auth'
import { shouldShowDevTools } from '@/utils/environment'

interface DevelopmentOnlyProps {
  children: ReactNode
}

/**
 * Conditional wrapper for development tools and debug UI
 *
 * Access Policy: Centralized in shouldShowDevTools() function
 * - See utils/environment.ts for current policy configuration
 * - Policy can be changed via VITE_DEV_TOOLS_ACCESS env var
 *
 * Use this for inline development tools, debug controls, and utility UI.
 *
 * @example
 * <DevelopmentOnly>
 *   <DevToolsMenu />
 * </DevelopmentOnly>
 *
 * @example
 * <DevelopmentOnly>
 *   <button onClick={handleDebug}>Debug Info</button>
 * </DevelopmentOnly>
 */
export function DevelopmentOnly({ children }: DevelopmentOnlyProps) {
  const { isAdmin } = useAuth()

  // Check centralized policy
  if (shouldShowDevTools(isAdmin)) {
    return <>{children}</>
  }

  return null
}
